'use client';

import { ColorVariant, labelColorVariants } from '@/shared/styles/labelColorVariants';
import React from 'react';

interface LabelBadgeProps {
  color: ColorVariant;
  children: React.ReactNode;
}

const LabelBadge = ({ color, children }: LabelBadgeProps) => {
  const variant = labelColorVariants[color];

  return (
    <span
      className={`inline-block rounded-md border px-2 py-1 text-xs whitespace-nowrap ${variant.bgColor} ${variant.textColor} ${variant.borderColor}`}>
      {children}
    </span>
  );
};

export default LabelBadge;
